import { Viewer} from "../viewer/viewer"

export type MsgFunc = (message: string | undefined) => void

export interface LogRef {
  enable: boolean
}

/**
 * API for the UltraViewer component.
 * Wraps calls to update the viewer and display messages.
 */
export class ComponentRef {
  private _viewer: Viewer
  private _message: MsgFunc
  readonly logs: LogRef

  constructor(viewer: Viewer, message: MsgFunc, logs: LogRef) {
    this._viewer = viewer
    this._message = message
    this.logs = logs
  }

  get viewer() {
    return this._viewer
  }

  /**
   * Display a message in the react ui.
   * @param message message to display. Undefined to clear the message.
   */
  message(message: string | undefined) {
    this._message(message)
  }

  /**
   * Load a vim file from a url or local path on the server.
   * @param url url or local path to the vim file.
   * @returns a request object that can be used to wait for the load to complete.
   */
  load(url: string) {
    const request = this._viewer.loadVim(url)
    
    return request
  }
}
